import { useAppConfiguration } from "core/gateways/mobile-system/system.hooks";
import { useEffect } from "react";

/*Merges any config secrets that need to be fetched asynchronously */
export const useMergeAppConfigSecrets = () => {
  const { data: appConfig, isLoading, error } = useAppConfiguration();

  useEffect(() => {
    if (
      appConfig?.syncFusionKey &&
      window.appConfig.syncFusionKey !== appConfig.syncFusionKey
    ) {
      window.appConfig.syncFusionKey = appConfig.syncFusionKey;
    }
  }, [appConfig]);

  return { isLoading, error };
};
